import React from 'react';
import { Box } from '@mui/material';
import TopAppBar from '../layout/TopAppBar';
import BottomNavigationBar from '../layout/BottomBar';

const HOW_CONVIVIAL_URL = 'https://www.convivialapp.it/come-funziona-da-app/';

export default function MoreInfoPage() {
    return (
        <>
            <TopAppBar title="ConvivialApp.it" variant="back" showAvatar={!!localStorage.getItem('user_id')} />
            <Box
                component="main"
                sx={{
                    pt: 'var(--cv-top-bar-height)',
                    pb: 'var(--cv-bottom-nav-height)',
                    height: '100dvh',
                    bgcolor: 'background.default',
                }}
            >
                <Box
                    component="iframe"
                    title="Come funziona Convivial"
                    src={HOW_CONVIVIAL_URL}
                    sx={{
                        display: 'block',
                        width: '100%',
                        height: '100%',
                        border: 0,
                        bgcolor: 'background.default',
                    }}
                />
            </Box>
            <BottomNavigationBar valueToHighlight={0} />
        </>
    );
}
